import React from 'react';
// import AwardIMG from '@public/images/math/award.png';
import Image from 'next/image';
import { i18n, useTranslation } from 'next-i18next';

import { Autoplay } from 'swiper';
// import { CheckIcon } from '@/components/Math/SVG/CheckIcon';
// import MathGirlImg from '@public/images/math/math-girl.png';
import { Swiper, SwiperSlide } from 'swiper/react';

import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import SmallScreen from '@/components/Device/SmallScreen';
import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

import useIsMobile from '@/hooks/useIsMobile';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const International = () => {
  const { t } = useTranslation(['home', 'path', 'math']);

  const list = [
    {
      rate: '97%',
      text: t('math:获得提升'),
    },
    {
      rate: '93%',
      text: t('math:积极影响'),
    },
    {
      rate: '91%',
      text: t('math:满分好评'),
    },
  ];
  const awards = {
    zh: [
      {
        avatar: '/images/math/avatar/stu1.svg',
        content: '悟空学员Gavin获得2023 AMC8全球排名前1%',
      },
      {
        avatar: '/images/math/avatar/stu2.svg',
        content: '悟空学员Tony获得2023 袋鼠数学加拿大全国赛第5名',
      },
      {
        avatar: '',
        content: '悟空学员在2023袋鼠数学澳新赛区捷报频传，每3位参赛学员有2位获奖',
      },
      {
        avatar: '/images/math/avatar/stu3.svg',
        content: '悟空学员Andrew获得2023 袋鼠数学最高荣誉High Distinction',
      },
      {
        avatar: '/images/math/avatar/stu4.svg',
        content: '悟空学员Kipper Li夺得2023 AMC8满分',
      },
    ],
    en: [
      {
        avatar: '/images/math/avatar/stu1.svg',
        content: 'WuKong student Gavin ranks top 1% globally in the 2023 AMC8.',
      },
      {
        avatar: '/images/math/avatar/stu2.svg',
        content: 'WuKong student Tony achieves 5th place in the 2023 Kangaroo Math Competition in Canada.',
      },
      {
        avatar: '',
        content:
          'WuKong students shine in the 2023 Kangaroo Math Competition Oceania region, with a 2 in 3 chance of winning.',
      },
      {
        avatar: '/images/math/avatar/stu3.svg',
        content:
          'WuKong student Andrew receives the highest honor, High Distinction, in the 2023 Kangaroo Math Competition.',
      },
      {
        avatar: '/images/math/avatar/stu4.svg',
        content: '',
      },
    ],
  };

  const isMobile = useIsMobile();

  return (
    <>
      <div className="container relative mt-[5rem] lg:mt-[140px] xl:mt-[200px]">
        <MaxAndMediumScreen>
          <Title theme="math" innerHTML className="">
            {t('math:国际-标题')}
          </Title>
        </MaxAndMediumScreen>
        <SmallScreen>
          <Title theme="math" innerHTML className="">
            {t('math:国际-标题-small')}
          </Title>
        </SmallScreen>
        <div className="relative mt-[24px] rounded-[24px] bg-[linear-gradient(90deg,rgba(0,156,255,0.06)0%,rgba(0,156,255,0.05)101%)] lg:mt-[60px] lg:w-[980px] lg:px-[40px] lg:py-[36px] xl:mt-[60px] xl:w-[1400px] xl:rounded-[36px] xl:px-[170px] xl:py-[73px]">
          {/* xl */}
          <div className="hidden flex-wrap xl:flex">
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/1920-1-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国AMC' : 'American Mathematics Competition'}
                className="w-[280px]"
                loading="lazy"
                width={280}
                height={100}
              />
              <Image
                src={`/images/math/org/1920-2-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '袋鼠国际竞赛' : 'International Mathematics Kangaroo'}
                className="w-[280px]"
                loading="lazy"
                width={280}
                height={100}
              />
            </div>
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/1920-3-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '澳洲AMC' : 'Australian Mathematics Competition'}
                className="w-[280px]"
                loading="lazy"
                width={280}
                height={100}
              />
              <Image
                src={`/images/math/org/1920-4-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国大联盟' : 'American Invitational Mathematics Examination'}
                className="w-[280px]"
                loading="lazy"
                width={280}
                height={100}
              />
            </div>
          </div>
          <div className="hidden flex-wrap lg:flex xl:hidden">
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/1024-1-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国AMC' : 'American Mathematics Competition'}
                className="w-[240px]"
                loading="lazy"
                width={240}
                height={100}
              />
              <Image
                src={`/images/math/org/1024-2-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '袋鼠国际竞赛' : 'International Mathematics Kangaroo'}
                className="w-[240px]"
                loading="lazy"
                width={240}
                height={100}
              />
            </div>
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/1024-3-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '澳洲AMC' : 'Australian Mathematics Competition'}
                className="w-[240px]"
                loading="lazy"
                width={240}
                height={100}
              />
              <Image
                src={`/images/math/org/1024-4-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国大联盟' : 'American Invitational Mathematics Examination'}
                className="w-[240px]"
                loading="lazy"
                width={240}
                height={100}
              />
            </div>
          </div>
          <div className="flex flex-wrap justify-center pt-[1.5rem] lg:hidden xl:hidden">
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/375-1-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国AMC' : 'American Mathematics Competition'}
                className="w-[8.75rem]"
                loading="lazy"
                width={240}
                height={100}
              />
              <Image
                src={`/images/math/org/375-2-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '袋鼠国际竞赛' : 'International Mathematics Kangaroo'}
                className="w-[8.75rem]"
                loading="lazy"
                width={240}
                height={100}
              />
            </div>
            <div className="flex justify-between">
              <Image
                src={`/images/math/org/375-3-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '澳洲AMC' : 'Australian Mathematics Competition'}
                className="w-[8.75rem]"
                loading="lazy"
                width={240}
                height={100}
              />
              <Image
                src={`/images/math/org/375-4-${i18n?.language || 'en'}.png`}
                alt={i18n?.language === 'zh' ? '美国大联盟' : 'American Invitational Mathematics Examination'}
                className="w-[8.75rem]"
                loading="lazy"
                width={240}
                height={100}
              />
            </div>
          </div>
          <div className="px-[1.25rem] lg:absolute lg:bottom-0 lg:right-[47px] lg:h-[326px] lg:w-[420px] lg:px-0 xl:absolute xl:bottom-0 xl:right-[100px] xl:h-[420px] xl:w-[540px] xl:px-0">
            <Image
              className="h-auto w-full"
              height={0}
              width={0}
              sizes="100vw"
              alt={i18n?.language === 'zh' ? '悟空国际数学在线直播课' : 'WuKong Math Online Classes'}
              src="/images/math/math-girl.png"
              loading="lazy"
            />
          </div>
        </div>
        <div className="mt-[24px] flex flex-col justify-between lg:w-[984px] lg:flex-row xl:w-[1400px] xl:flex-row">
          {list.map((item) => {
            return (
              <h3
                key={item.text}
                className="mb-[1rem] rounded-[24px] bg-[linear-gradient(180deg,rgba(0,156,255,0.06)0%,rgba(0,156,255,0.02)100%)]  px-[1.25rem] py-[0.75rem] lg:mb-0 lg:h-auto lg:w-[315px] lg:py-[24px] xl:mb-0 xl:h-auto xl:w-[450px] xl:rounded-[36px] xl:px-[40px] xl:py-[32px] [&]:last:mb-0"
              >
                <strong className="linearGradientForMath text-[1.75rem] lg:text-[34px] lg:leading-[normal] xl:text-[48px] xl:leading-[70px]">
                  {item.rate}{' '}
                </strong>
                <span
                  className={`text-base ${i18n?.language === 'zh' ? 'leading-8' : 'leading-[1.625rem]'} lg:text-[16px] lg:leading-[28px] xl:text-[18px] xl:leading-[36px]`}
                >
                  {item.text}
                </span>
              </h3>
            );
          })}
        </div>
        {!isMobile && (
          <div className="relative mt-[1.25rem] hidden before:absolute before:left-0 before:top-0 before:z-10 before:hidden before:h-[100%] before:w-[300px] before:bg-[linear-gradient(90deg,rgba(255,255,255,1)0%,rgba(255,255,255,0.1)100%)] after:absolute after:right-0 after:top-0 after:z-10 after:hidden after:h-[100%] after:w-[300px] after:bg-[linear-gradient(270deg,rgba(255,255,255,1)0%,rgba(255,255,255,0.1)100%)] lg:mt-[28px] lg:block lg:before:block lg:after:block xl:mt-[40px] xl:block xl:before:block">
            <Swiper
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              loop
              speed={5000}
              slidesPerView="auto"
              onSwiper={(swiper) => console.log(swiper)}
              modules={[Autoplay]}
              className="w-full !pb-[1.25rem] lg:!pb-[40px] xl:!pb-[40px] [&_.swiper-wrapper]:ease-linear"
            >
              {awards[(i18n?.language || 'en') as keyof typeof awards]?.map(
                (item: { avatar?: string; content: string }, key) => {
                  if (!item.content) {
                    return null;
                  }
                  return (
                    <SwiperSlide
                      key={key}
                      className="mr-[16px] box-border flex !h-auto !w-fit lg:mr-[40px] lg:max-w-[580px] xl:mr-[40px] xl:max-w-[640px]"
                    >
                      <div className="flex h-[100%] w-full items-center justify-between rounded-[9999px] bg-[linear-gradient(180deg,rgba(255,255,255,0.60)_0%,#FFF_100%)] p-[8px_20px_8px_20px] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] lg:p-[12px_32px_12px_32px] xl:p-[12px_32px_12px_32px]">
                        <img src="/images/math/left-paddy.svg" alt="" />
                        <div className="flex items-center justify-center">
                          {item?.avatar && (
                            <img src={item.avatar} alt="" className=" shrink-0 overflow-hidden rounded-full" />
                          )}
                          <p className="ml-[8px] text-[0.875rem] font-normal text-wk-words-1 lg:text-sm lg:font-semibold xl:text-base xl:font-semibold">
                            {item.content}
                          </p>
                        </div>
                        <img src="/images/math/right-paddy.svg" alt="" />
                      </div>
                    </SwiperSlide>
                  );
                },
              )}
            </Swiper>
            <div className="mt-[1rem] text-center lg:mt-[20px] xl:mt-[20px]">
              <LeadButton
                theme="math"
                subject="math"
                size="xl"
                className=""
                traceName="O_MathCourse_Competitions_CTAClick"
                traceGa4Name="new_entry_MathCourse_CompetitionsCTA"
              >
                {t('math:math-按钮')}
              </LeadButton>
            </div>
          </div>
        )}
      </div>
      {isMobile && (
        <div className="relative before:absolute before:left-0 before:top-0 before:z-10 before:hidden before:h-[100%] before:w-[300px] before:bg-[linear-gradient(90deg,rgba(255,255,255,1)0%,rgba(255,255,255,0.1)100%)] after:absolute after:right-0 after:top-0 after:z-10 after:hidden after:h-[100%] after:w-[300px] after:bg-[linear-gradient(270deg,rgba(255,255,255,1)0%,rgba(255,255,255,0.1)100%)] lg:mt-[28px] lg:hidden lg:after:block xl:mt-[40px] xl:hidden xl:before:block">
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            loop
            speed={5000}
            slidesPerView="auto"
            onSwiper={(swiper) => console.log(swiper)}
            modules={[Autoplay]}
            className="w-full !py-[2rem] [&_.swiper-wrapper]:ease-linear"
          >
            {awards[(i18n?.language || 'en') as keyof typeof awards]?.map(
              (item: { avatar?: string; content: string }, key) => {
                if (!item.content) {
                  return null;
                }
                return (
                  <SwiperSlide key={key} className="mr-[16px] box-border flex !h-auto !w-[335px]">
                    <div className="flex h-[100%] w-full items-center justify-between rounded-[24px] bg-[linear-gradient(180deg,rgba(255,255,255,0.60)_0%,#FFF_100%)] p-[8px_20px_8px_20px] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] lg:p-[12px_32px_12px_32px]">
                      <img src="/images/math/left-paddy.svg" alt="" />
                      <div className="flex items-center justify-center">
                        {item?.avatar && (
                          <img src={item.avatar} alt="" className=" shrink-0 overflow-hidden rounded-full" />
                        )}
                        <p className="ml-[8px] text-[0.875rem] font-normal text-wk-words-1 lg:text-sm lg:font-semibold xl:text-base xl:font-semibold">
                          {item.content}
                        </p>
                      </div>
                      <img src="/images/math/right-paddy.svg" alt="" />
                    </div>
                  </SwiperSlide>
                );
              },
            )}
          </Swiper>
          <div className="text-center lg:mt-[20px] xl:mt-[20px]">
            <LeadButton
              theme="math"
              subject="math"
              size="xl"
              className=""
              traceName="O_MathCourse_Competitions_CTAClick"
              traceGa4Name="new_entry_MathCourse_CompetitionsCTA"
            >
              {t('math:math-按钮')}
            </LeadButton>
          </div>
        </div>
      )}
    </>
  );
};

export default International;
